import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Typography } from "@material-ui/core";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      minHeight: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    },
    text: {
      marginTop: "16px"
    }
  };
});

var LoadingTemplate = function LoadingTemplate(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    size: 100
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.text
  }, props.text || "Loading"));
};

export { LoadingTemplate };